import React, { useState, useEffect } from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

const Footer = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // We'll create a reusable function to check the login status
  const checkLoginStatus = () => {
    const loginStatus = localStorage.getItem('isLoginTrue');
    setIsLoggedIn(loginStatus === 'true');
    console.log("Footer login status checked:", loginStatus === 'true'); // For debugging
  };

  useEffect(() => {
    // Check the status when the component first loads
    checkLoginStatus();

    // THIS IS THE CRITICAL FIX:
    // Listen for a custom event that we will fire from our login popup.
    // When this event happens, we run `checkLoginStatus` again.
    window.addEventListener('loginStateChange', checkLoginStatus);

    // This is a best practice: clean up the listener when the component
    // is no longer on the page to prevent memory leaks.
    return () => {
      window.removeEventListener('loginStateChange', checkLoginStatus);
    };
  }, []); // The empty array [] means this setup effect runs only once.

  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            {/* Brand Section */}
            <div className="footer-brand">
              <div className="footer-logo">
                <Link to="/">
                  <img src="/photos/fotrlogo.png" alt="Canada Study Visa" loading="lazy" />
                </Link>
              </div>
              <p>
                AI-powered personalized reports for education-based immigration
                planning. Your trusted partner in achieving your study abroad
                dreams.
              </p>
              <div className="contact-info">
                <div className="contact-item">
                  <div>
                    <div className="contact-label">
                      <img src="/photos/eml.png" alt="Australia Study Visa" loading="lazy" />
                      Email us
                    </div>
                    <div>support@getnextvisa.com</div>
                  </div>
                </div>
                <div className="contact-item">
                  <div>
                    <div className="contact-label">
                      <img src="/photos/phn.png" alt="Newzealand Study Visa" loading="lazy" />
                      Call us
                    </div>
                    <div>+91 7888818668</div>
                  </div>
                </div>
                <div className="contact-item">
                  <div>
                    <div className="contact-label">
                      <img src="/photos/loc.png" alt="UK Study Visa" loading="lazy" />
                      Visit us
                    </div>
                    <div>IT City Chandigarh, India</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Links Section Wrapper */}
            <div className="footer-links-grid">
              {/* Quick Links */}
              <div className="footer-section">
                <h3>Quick Links</h3>
                <ul className="footer-links">
                  <li><a href="/About">About Us</a></li>
                  <li><a href="/Itwork">How It Works</a></li>
                  <li><a href="/Pricing">Pricing</a></li>
                  <li><a href="/Contact">Contact</a></li>
                </ul>
              </div>
              {/* Our Services */}
              <div className="footer-section">
                <h3>Our Services</h3>
                <ul className="footer-links">
                  {isLoggedIn ? (
                    <>
                      {/* If logged in, these are Links to the dashboard */}
                      <li><Link to="/dashboard">AI-Powered Reports</Link></li>
                      <li><Link to="/dashboard">Basic Report</Link></li>
                      <li><Link to="/dashboard">Standard Report</Link></li>
                      <li><Link to="/dashboard">Premium Report</Link></li>
                      <li><Link to="/dashboard">Counselling</Link></li>
                    </>
                  ) : (
                    <>
                      {/* If not logged in, these trigger the login popup */}
                      <li><a className="trigger-login-popup" style={{ cursor: 'pointer' }}>AI-Powered Reports</a></li>
                      <li><a className="trigger-login-popup" style={{ cursor: 'pointer' }}>Basic Report</a></li>
                      <li><a className="trigger-login-popup" style={{ cursor: 'pointer' }}>Standard Report</a></li>
                      <li><a className="trigger-login-popup" style={{ cursor: 'pointer' }}>Premium Report</a></li>
                      <li><a className="trigger-login-popup" style={{ cursor: 'pointer' }}>Counselling</a></li>
                    </>
                  )}
                </ul>
              </div>
              {/* Resources & Legal Sections */}
              <div className="footer-section">
                <h3>Resources</h3>
                <ul className="footer-links">
                  <li><a href="https://www.getnextvisa.com/blogs" target="_blank" rel="noopener noreferrer">Blog</a></li>
                  <li><a href="/contact">FAQ</a></li>
                  <li><a href="/contact">Help Center</a></li>
                </ul>
              </div>
              <div className="footer-section">
                <h3>Legal</h3>
                <ul className="footer-links">
                  <li><a href="/privacy-policy">Privacy Policy</a></li>
                  <li><a href="/terms">Terms of Service</a></li>
                  <li><a href="/refund-policy">Refund Policy</a></li>
                </ul>
              </div>
            </div>
          </div>
          {/* Social Section & Stats */}
          <div className="journey">
            <div className="social-section">
              <h3>Follow Our Journey</h3>
              <div className="social-links">
                <a href="https://www.instagram.com/getnextvisa/" className="social-link"><img src="/photos/q2.png" alt="USA Study Visa" loading="lazy" /></a>
                <a href="https://www.facebook.com/getnextvisa" className="social-link"><img src="/photos/q4.png" alt="Germany Study Visa" loading="lazy" /></a>
                <a href="https://x.com/GetNextVisa" className="social-link"><img src="/photos/q5.png" alt="Germany Education Visa" loading="lazy" /></a>
              </div>
            </div>
            <div className="stats-section">
              <div className="stat-item">
                <div className="state-number">10K+</div>
                <div className="state-label">Students Helped</div>
              </div>
              <div className="stat-item">
                <div className="state-number">200+</div>
                <div className="state-label">Countries Rate</div>
              </div>
              <div className="stat-item">
                <div className="state-number">95%</div>
                <div className="state-label">Success Rate</div>
              </div>
            </div>
          </div>
          {/* Footer Bottom */}
          <div className="footer-bottom">
            <div className="copyright">
              © 2025 Get Next Visa. All rights reserved | Designed and Developed by <a href="https://indraq.com" target="_blank" rel="noopener noreferrer">IndraQ Innovations</a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;